import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { ClassLimitReachedDialogComponent } from './class-limit-reached-dialog.component';

export const CLASS_LIMIT_REACHED_DIALOG_ID = 'class-limit-reached-dialog';

@Injectable({ providedIn: 'root' })
export class ClassLimitReachedDialogService extends AbstractDialogService<void, boolean> {
  readonly id = CLASS_LIMIT_REACHED_DIALOG_ID;
  protected override readonly component = ClassLimitReachedDialogComponent;
  protected override readonly options = {
    cssClass: 'class-limit-reached-dialog auto-height action-sheet-on-mobile',
  };

  async open(): Promise<boolean | undefined> {
    return this.openDialog({ isSingleBreakpoint: true });
  }
}
